import 'jqvmap/dist/jquery.vmap.min';
import 'jqvmap/dist/maps/jquery.vmap.france';

import '../modules/tooltips';
import '../modules/slick-slider';
// import '../modules/halfButton';
// import '../modules/slider-no-desktop-lg';
import '../modules/checkbox-button';
import '../modules/search';
